import { BusinessContextDefinition } from './BusinessContextDefinition';
import { BusinessContextNotes } from './BusinessContextNotes';
import { BusinessContextOwner } from './BusinessContextOwner';
import { BusinessContextStakeholder } from './BusinessContextStakeholder';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { DetailSection } from '@periscopes/general';
import React from 'react';
import { coreActions, FeatureFlag } from '@sonar-software/sonar-core';
import { useAction, useFeatureFlag, useOnMount } from '@hooks';
export const BusinessContext = ({ autodocDisabled, sonarObjectId }) => {
    const isEnabledDataDictionary = useFeatureFlag(FeatureFlag.DataDictionary);
    const getBusinessContext = useAction(coreActions.requestGetCoreSonarObjectsContext);
    useOnMount(() => {
        if (isEnabledDataDictionary) {
            getBusinessContext({ sonarObjectId });
        }
    });
    if (!isEnabledDataDictionary) {
        return null;
    }
    return (React.createElement(DetailSection, { title: COPY_SPECIFIC.BUSINESS_CONTEXT },
        React.createElement(BusinessContextOwner, { sonarObjectId: sonarObjectId }),
        React.createElement(BusinessContextStakeholder, { sonarObjectId: sonarObjectId }),
        React.createElement(BusinessContextDefinition, { autodocDisabled: autodocDisabled, sonarObjectId: sonarObjectId }),
        React.createElement(BusinessContextNotes, { sonarObjectId: sonarObjectId })));
};
